export default {
    searchAgent: {
        create: 'Create search agent'
    }
}
